import React from 'react';
import { formatCurrency } from 'utils';
import { Typography } from '@mui/material';
import { Control, useWatch } from 'react-hook-form';

import { calculateNetTrade } from '../../../../lib';
import { DealBuilderFormValues } from '../../../../types';

interface Props {
  control: Control<DealBuilderFormValues>;
  rowIndex: number;
}

export const NetTradeCell = ({ control, rowIndex }: Props) => {
  const [tradeInValue, amountOwed] = useWatch({
    control,
    name: [`pricing.tradeIn.${rowIndex}.tradeInValue`, `pricing.tradeIn.${rowIndex}.amountOwed`],
  });

  const netTrade = calculateNetTrade({ tradeInValue, amountOwed });

  return <Typography>{formatCurrency(netTrade, true)}</Typography>;
};
